import fetch from '@/service/fetch'
import type {
  QualificationsApi,
  FinanceInfoApi,
  GetDeveloperInfo,
  SetQualificationsApi,
  SetFinanceInfo,
  EditContactInfoApi,
  RequestGetExamineStatus,
  GetInvoiceTypeApi,
  FileOcrRecognitionType,
  SetFinanceForeignInfoApi,
  SetDeveloperCertificationApi
} from '../types'

/**
 * 获取公司资质信息
 */
const reqQualifications: QualificationsApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/getQualifications', data })
}

/**
 * 获取财务信息
 */
const reqFinanceInfo: FinanceInfoApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/getFinanceInfo', data })
}

/**
 * 获取联系人信息
 */
const getDeveloperInfo: GetDeveloperInfo = (data = {}) => {
  return fetch({ method: 'post', url: '/account/getDeveloperInfo', data })
}

/**
 * 编辑公司资质信息（已废弃）
 */
const reqSetQualifications: SetQualificationsApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/setQualifications', data })
}

/**
 * 修改财务信息（国内）(已废弃)
 */
const reqSetFinanceInfo: SetFinanceInfo = (data = {}) => {
  return fetch({ method: 'post', url: '/account/setFinance', data })
}

/**
 * 修改财务信息 （国际）（已废弃）
 */
const reqSetFinanceForeignInfo: SetFinanceForeignInfoApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/setFinanceForeign', data })
}

/**
 * 编辑联系人信息（已废弃）
 */
const reqEditContactInfo: EditContactInfoApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/editDeveloperInfo', data })
}

// 获取审核状态
const requestGetExamineStatus: RequestGetExamineStatus = (data = {}) => {
  return fetch({ method: 'post', url: '/account/getExamineStatus', data })
}

/**
 * 获取发票类型
 */
const reqGetInvoiceType: GetInvoiceTypeApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/getInvoiceType', data })
}

//文件OCR识别
const fileOcrRecognition: FileOcrRecognitionType = (data = {}) => {
  return fetch({ method: 'post', url: '/account/fileOcrRecognition', data })
}

/**
 * 编辑公司资质、财务、联系人统一提交接口
 */
const reqSetDeveloperCertification: SetDeveloperCertificationApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/setDeveloperCertificationData', data })
}

/**
 * 更新公司资质
 */
const updateDeveloperCertificationDataRequest = (data = {}) => {
  return fetch({ method: 'post', url: '/account/updateDeveloperCertificationData', data })
}

export {
  reqQualifications,
  reqFinanceInfo,
  getDeveloperInfo,
  reqSetQualifications,
  reqSetFinanceInfo,
  reqEditContactInfo,
  requestGetExamineStatus,
  reqGetInvoiceType,
  fileOcrRecognition,
  reqSetFinanceForeignInfo,
  reqSetDeveloperCertification,
  updateDeveloperCertificationDataRequest
}
